import Vue from 'vue';
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader */

Vue.use(Vuetify);

export default new Vuetify({
    icons: { iconfont: 'mdi' },
    theme: {
        themes: {
            light: {
                primary: {
                    base: '#607D8B',//blu-grey',
                    lighten1: '#90A4AE',
                    lighten2: '#B0BEC5'
                },
                secondary: {/*indigo darken-4*/
                    base:'#1A237E',//
                },
                accent: '#CDDC39',/*lime*/
                error: '#BF360C',/*deep-orange*/ 
            }
        },
    },
});


